"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppBaseOnePerOwnerRowId = isAppBaseOnePerOwnerRowId;
exports.appBaseOnePerOwnerRowId = appBaseOnePerOwnerRowId;
const app_base_contract_1 = require("./app-base-contract");
const ONE_PER_OWNER_ROW_ID_PREFIX = 'opo_';
/** Recognizes the server-generated admission key without duplicating its prefix. */
function isAppBaseOnePerOwnerRowId(rowId) {
    return rowId.startsWith(ONE_PER_OWNER_ROW_ID_PREFIX);
}
/**
 * Stable admission key for onePerOwner: the same for the same table, person
 * and value. The writer chooses a fresh physical row id when it creates a row,
 * so a deleted locator is never reused. The person comes from the session,
 * never from input; this key carries nothing that can be read back.
 */
function appBaseOnePerOwnerRowId(input) {
    const digest = (0, app_base_contract_1.appBaseSha256Hex)(JSON.stringify([
        'one-per-owner',
        input.sourceKey,
        input.owner.type,
        input.owner.id,
        input.value,
    ]));
    return `${ONE_PER_OWNER_ROW_ID_PREFIX}${digest.slice(0, 40)}`;
}
